export default __webpack_public_path__ + "static/media/dark-green-spring.de9dac33.png";